import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { stripClientPrefix } from '../utils/modulesNavigation';

/**
 * Hook to extract the current entity name from the URL path.
 * Works for routes like:
 * - /clientId/:clientId/entities/:entityName
 * - /clientId/:clientId/entities/:entityName/:entityId
 *
 * @returns The entity name from the URL, or empty string if not on an entity route
 */
export function useCurrentEntityName(): string {
  const { pathname } = useLocation();

  return useMemo(() => {
    const pathWithoutClient = stripClientPrefix(pathname);
    const regex = /^\/entities\/([^/]+)/;
    const match = regex.exec(pathWithoutClient);
    return match?.[1] ?? '';
  }, [pathname]);
}
